import { ModalId } from '../../../../../enums/modalId'
import { useWarningModals } from '../../../../../hooks/useWarningModals'
import { AccountingBasisConfirmationModal } from '../elements/AccountingBasisConfirmationModal'
import { OrganizationAccountingForm } from '../utils/organizationAccountingSettingsFormData'

export const useOrganizationAccountingWarningModals = () => {
  return useWarningModals<OrganizationAccountingForm>({
    warnings: {
      [ModalId.AccountingBasisConfirmationModal]: 'accountingBasis',
    },
    modals: <AccountingBasisConfirmationModal id={ModalId.AccountingBasisConfirmationModal} />,
  })
}
